import React, { useState, useEffect } from 'react';
import moment from 'moment';

const CountdownTimer = ({ className, endDateTimeMoment, onTimerComplete }) => {
    const [timeRemaining, setTimeRemaining] = useState(moment.duration());
    const [timerStarted, setTimerStarted] = useState(false);
    useEffect(() => {
        const interval = setInterval(() => {
            setTimeRemaining(() => {
                const endTime = endDateTimeMoment;
                const now = moment.tz('America/Chicago').local();
                const duration = endTime - now;
                const remaining = moment.duration(duration, 'ms');
                setTimeRemaining(remaining);
                if (timerStarted === false) {
                    setTimerStarted(true);
                }
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [endDateTimeMoment]);

    useEffect(() => {
        if (timerStarted && timeRemaining.asMilliseconds() <= 0 && onTimerComplete) {
          onTimerComplete(timeRemaining);
        }
    }, [timeRemaining, timerStarted]);

    const timeRemainingText = () => {
        const days = timeRemaining.days() > 0 ? timeRemaining.days() + 'd '  : '';
        const hours = timeRemaining.hours() > 0 || days !== '' ? timeRemaining.hours() + 'h ' : '';
        const minutes = timeRemaining.minutes() > 0 || hours !== '' ? timeRemaining.minutes() + 'm ' : '';
        const seconds = timeRemaining.seconds() > 0 || minutes !== '' ? timeRemaining.seconds() + 's' : '';
        return `${days}${hours}${minutes}${seconds}`;
    };
    return (
        <span className={className} style={timeRemaining.days() > 0 ? { color: 'green' } : null}>
          {`Time Remaining: ${timeRemainingText()}`}
        </span>
    );
};

export default CountdownTimer;

